<div class="card">
  <div class="card-body">
    <p class="mt-3">{{ card.ExternalRefNumber }}</p>
    <fgbcl-mobile-pass [memberId]="card.MemberId"></fgbcl-mobile-pass>
  </div>
</div>
